// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.current-survey
{
	margin: 0px auto;
	z-index: 5002;
	position: relative;
	width: 414px;
	max-width: 800px;
	height: 100%;
	box-sizing: border-box;
	color: #222;
}

	.current-survey.survey-mode
	{
		width: auto;
		padding-left: 40px;
		padding-right: 40px;
		padding-top: 20px;
		padding-bottom: 20px;
	}

		.current-survey.survey-mode .survey-step
		{
			border-radius: 5px;
		}

	.current-survey .survey-loading-indicator
	{
		text-align: center;
		color: #bbb;
		padding-bottom: 10px;
	}

@media (max-width: 768px)
{
	.current-survey
	{
		width: auto;
	}

		.current-survey.survey-mode
		{
			margin-top: 0;
			margin-bottom: 0;
			padding-left: 0;
			padding-right: 0;
			padding-top: 0;
			padding-bottom: 0;
		}

			.current-survey.survey-mode .survey-step
			{
				border-radius: 0;
			}
}

.current-survey .current-survey-content
{
	background: #FFF;
	border-radius: 5px;
	text-align: center;
	height: 100%;
}

.current-survey .current-survey-content > div
{
	height: 100%;
}

.current-survey .survey-loading
{
	padding: 20px;
}

.current-survey .nav-validation-modal
{
	font-family: Helvetica, Arial, sans-serif;
}

	.current-survey .nav-validation-modal .validation-message
	{
		font-size: 16px;
		padding-top: 15px;
		padding-bottom: 15px;
		font-weight: bold;
	}

	.current-survey .nav-validation-modal .validation-cancel-container
	{
		border-top: solid 1px #ddd;
	}

	.current-survey .nav-validation-modal .validation-cancel
	{
		padding: 15px;
		color: #0067B1;
		display: inline-block;
		background: #FFF;
		outline: none !important;
		font-size: 16px;
		cursor: pointer;
		font-weight: bold;
	}

	.current-survey .nav-validation-modal .validation-content
	{
		background: #FFF;
		border-radius: 5px;
		text-align: center;
		z-index: 6001;
		width: 325px;
		position: fixed !important;
	}

	.current-survey .nav-validation-modal .validation-overlay
	{
		position: fixed !important;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: #000;
		opacity: .25;
		z-index: 6000 !important;
	}

.current-survey-overlay
{
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	height: 100%;
	background: #000;
	opacity: .7;
	z-index: 5000;
}`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/SurveyCompletion/SurveyModal.css"],"names":[],"mappings":"AAAA;;CAEC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,sBAAsB;CACtB,WAAW;AACZ;;CAEC;;EAEC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;CACrB;;EAEC;;GAEC,kBAAkB;EACnB;;CAED;;EAEC,kBAAkB;EAClB,WAAW;EACX,oBAAoB;CACrB;;AAED;;CAEC;;EAEC,WAAW;CACZ;;EAEC;;GAEC,aAAa;GACb,gBAAgB;GAChB,eAAe;GACf,gBAAgB;GAChB,cAAc;GACd,iBAAiB;EAClB;;GAEC;;IAEC,gBAAgB;GACjB;AACH;;AAEA;;CAEC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;AACb;;AAEA;;CAEC,YAAY;AACb;;AAEA;;CAEC,aAAa;AACd;;AAEA;;CAEC,yCAAyC;AAC1C;;CAEC;;EAEC,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;CAClB;;CAEA;;EAEC,0BAA0B;CAC3B;;CAEA;;EAEC,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,iBAAiB;CAClB;;CAEA;;EAEC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,0BAA0B;CAC3B;;CAEA;;EAEC,0BAA0B;EAC1B,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;CACzB;;AAED;;CAEC,eAAe;CACf,OAAO;CACP,MAAM;CACN,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,aAAa;AACd","sourcesContent":[".current-survey\n{\n\tmargin: 0px auto;\n\tz-index: 5002;\n\tposition: relative;\n\twidth: 414px;\n\tmax-width: 800px;\n\theight: 100%;\n\tbox-sizing: border-box;\n\tcolor: #222;\n}\n\n\t.current-survey.survey-mode\n\t{\n\t\twidth: auto;\n\t\tpadding-left: 40px;\n\t\tpadding-right: 40px;\n\t\tpadding-top: 20px;\n\t\tpadding-bottom: 20px;\n\t}\n\n\t\t.current-survey.survey-mode .survey-step\n\t\t{\n\t\t\tborder-radius: 5px;\n\t\t}\n\n\t.current-survey .survey-loading-indicator\n\t{\n\t\ttext-align: center;\n\t\tcolor: #bbb;\n\t\tpadding-bottom: 10px;\n\t}\n\n@media (max-width: 768px)\n{\n\t.current-survey\n\t{\n\t\twidth: auto;\n\t}\n\n\t\t.current-survey.survey-mode\n\t\t{\n\t\t\tmargin-top: 0;\n\t\t\tmargin-bottom: 0;\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t\tpadding-top: 0;\n\t\t\tpadding-bottom: 0;\n\t\t}\n\n\t\t\t.current-survey.survey-mode .survey-step\n\t\t\t{\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n}\n\n.current-survey .current-survey-content\n{\n\tbackground: #FFF;\n\tborder-radius: 5px;\n\ttext-align: center;\n\theight: 100%;\n}\n\n.current-survey .current-survey-content > div\n{\n\theight: 100%;\n}\n\n.current-survey .survey-loading\n{\n\tpadding: 20px;\n}\n\n.current-survey .nav-validation-modal\n{\n\tfont-family: Helvetica, Arial, sans-serif;\n}\n\n\t.current-survey .nav-validation-modal .validation-message\n\t{\n\t\tfont-size: 16px;\n\t\tpadding-top: 15px;\n\t\tpadding-bottom: 15px;\n\t\tfont-weight: bold;\n\t}\n\n\t.current-survey .nav-validation-modal .validation-cancel-container\n\t{\n\t\tborder-top: solid 1px #ddd;\n\t}\n\n\t.current-survey .nav-validation-modal .validation-cancel\n\t{\n\t\tpadding: 15px;\n\t\tcolor: #0067B1;\n\t\tdisplay: inline-block;\n\t\tbackground: #FFF;\n\t\toutline: none !important;\n\t\tfont-size: 16px;\n\t\tcursor: pointer;\n\t\tfont-weight: bold;\n\t}\n\n\t.current-survey .nav-validation-modal .validation-content\n\t{\n\t\tbackground: #FFF;\n\t\tborder-radius: 5px;\n\t\ttext-align: center;\n\t\tz-index: 6001;\n\t\twidth: 325px;\n\t\tposition: fixed !important;\n\t}\n\n\t.current-survey .nav-validation-modal .validation-overlay\n\t{\n\t\tposition: fixed !important;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tbackground: #000;\n\t\topacity: .25;\n\t\tz-index: 6000 !important;\n\t}\n\n.current-survey-overlay\n{\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n\theight: 100%;\n\tbackground: #000;\n\topacity: .7;\n\tz-index: 5000;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
